// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.course-list {
    display: flex;
    justify-content: center;
}
.btn-creat-course {
    float: right;
    margin-top: 5px;
}
tbody {
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Dashboard.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,eAAe;AACnB;AACA;IACI,eAAe;AACnB","sourcesContent":[".course-list {\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n.btn-creat-course {\r\n    float: right;\r\n    margin-top: 5px;\r\n}\r\ntbody {\r\n    cursor: pointer;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
